//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    name: 'JobPostCard',

    props: {

        // The job object to display
        job: {
            type: Object,
            required: true
        }
    },

    computed: {
        height() {
            if (this.$breakpoint.xsOnly) {
                return 'unset'
            }

            return 410;
        }
    }
}
